import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import classNames from "classnames/bind"
import styles from "./columns-text-cards.module.css"
import BlockHeader from "@/common/partials/block-header/block-header"

export default function ColumnsTextCards({ block }) {
  const { attrs, innerBlocks } = block
  const cx = classNames.bind(styles)

  if (innerBlocks.length === 0) {
    return null
  }

  const classes = {
    wrapper: true,
    "layout-half": attrs.layout === "half",
    "layout-third": attrs.layout === "third",
    "layout-60-40": attrs.layout === "60-40",
    "layout-40-60": attrs.layout === "40-60",
    "layout-fourth": attrs.layout === "fourth",
    ["bg-color-" + attrs.bgColor]: attrs.bgColor
  }

  return (
    <Block
      block={block}
      width="bleed"
      innerWrapper={true}
      gap={block.attrs.blockGap}
      className={cx(classes)}>
      <BlockHeader
        heading={block?.attrs?.heading}
        text={block?.attrs?.text}
        align={block?.attrs?.align}
      />
      <div className="cards">
        <Blocks blocks={innerBlocks} />
      </div>
    </Block>
  )
}
